/**
 * 🔥 BroadcastChannel لمزامنة بيانات المتاجر بين التبويبات
 */

class StoreSync {
    constructor() {
        this.channels = new Map(); // slug -> BroadcastChannel
    }

    /**
     * إنشاء أو الحصول على channel لمتجر معين
     */
    getChannel(slug) {
        if (!slug) return null;

        if (!this.channels.has(slug)) {
            const channel = new BroadcastChannel(`store-${slug}`);

            // الاستماع للرسائل من التبويبات الأخرى
            channel.onmessage = (event) => {
                const { type, data } = event.data;

                switch (type) {
                    case 'STORE_ID_UPDATED':

                        localStorage.setItem(`store-id-${slug}`, data.storeId);
                        break;

                    case 'STORE_DATA_UPDATED':

                        Object.keys(data).forEach(key => {
                            localStorage.setItem(`${key}-${slug}`,
                                typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key]
                            );
                        });
                        break;

                    case 'STORE_CLOSED':

                        // يمكنك إضافة logic هنا إذا أردت
                        break;

                    default:

                }
            };

            this.channels.set(slug, channel);

        }

        return this.channels.get(slug);
    }

    /**
     * إرسال تحديث store-id
     */
    broadcastStoreId(slug, storeId) {
        const channel = this.getChannel(slug);
        if (channel) {
            channel.postMessage({
                type: 'STORE_ID_UPDATED',
                data: { storeId }
            });

        }
    }

    /**
     * إرسال تحديث بيانات المتجر
     */
    broadcastStoreData(slug, data) {
        const channel = this.getChannel(slug);
        if (channel) {
            channel.postMessage({
                type: 'STORE_DATA_UPDATED',
                data
            });

        }
    }

    /**
     * إغلاق channel لمتجر معين
     */
    closeChannel(slug) {
        const channel = this.channels.get(slug);
        if (channel) {
            // إرسال رسالة إغلاق قبل الإغلاق
            channel.postMessage({
                type: 'STORE_CLOSED',
                data: { slug }
            });

            channel.close();
            this.channels.delete(slug);

        }
    }

    /**
     * إغلاق جميع الـ channels
     */
    closeAll() {
        this.channels.forEach((channel, slug) => {
            this.closeChannel(slug);
        });

    }
}

// Singleton instance
export const storeSync = new StoreSync();
